export default __webpack_public_path__ + "static/media/business-item-1.f50bf077.jpg";